export const musicList1 = [
  {
    title: "맞춤 섹션",
    id: "section1",
    photo: "https://dongsooo.github.io/imgs/img/01_section-01.jpg",
    musicTitle: "City Pop Radio",
  },
  {
    id: "section2",
    photo: "https://dongsooo.github.io/imgs/img/01_section-02.jpg",
    musicTitle: "M83 - Hurry Up, We're Dreaming",
  },
  {
    id: "section3",
    photo: "https://dongsooo.github.io/imgs/img/01_section-03.jpg",
    musicTitle: "Deen - Twilight City",
  },
  {
    id: "section4",
    photo: "https://dongsooo.github.io/imgs/img/01_section-04.jpg",
    musicTitle: "Bronze - Skyline",
  },
  {
    id: "section5",
    photo: "https://dongsooo.github.io/imgs/img/01_section-05.jpg",
    musicTitle: "Summertime city pop",
  },
];
